import ROUTES from '../SalesReportContainer/reportRoutes';
import {
  createProductServiceSalesHashLink,
  resolveEmployeeFilterForChannel,
} from '../common/createProductServiceSalesNavLink';

export default createProductServiceSalesHashLink({
  route: ROUTES.SERVICE_SALES_REPORT,
  includeChannel: true,
  displayName: 'ServiceSalesLink',
  resolveRouteEmployeeFilter: resolveEmployeeFilterForChannel,
  getOnClickArgs: ({ fromDate, toDate, selectedChannel, employeeFilter }) => [
    fromDate,
    toDate,
    selectedChannel,
    employeeFilter,
  ],
});
